import type { ILogging } from '../../../api/types/ILogging';
import type { UnknownObject } from '../../../types';
export type LoggingChannel =
  | 'firebase'
  | 'amplitude'
  | 'braze'
  | 'ablylog'
  | 'facebook'
  | 'airbridge'
  | 'pixel';

export const LOG_ANALYTICS_ALL_CHANNELS: Array<LoggingChannel> = [
  'firebase',
  'amplitude',
  'braze',
  'ablylog',
  'facebook',
  'airbridge',
];
export type LogAnalyticsEventParams = {
  channel?: Array<LoggingChannel>;
  name: string;
  /**
   * - 키는 대문자, snake case로 작성합니다.
   * - SCREEN이 있는지 확인해주세요
   */
  analytics?: UnknownObject;
  ably_only_log?: UnknownObject;
  ignoreAblyLog?: boolean;
  /**
   * ILogging을 전달하면 analytics, ably_only_log를 자동으로 추출합니다.
   * analytics, ably_only_log와 함께 사용하면 logging 값 위에 머지됩니다.
   */
  logging?: ILogging;
  /**
   * 웹 전용: true면 버퍼링하지 않고 즉시 전송(flush)하고 그 Promise를 반환한다.
   * window.location 하드 네비게이션 직전에 await하면 로그 유실을 막는다.
   */
  immediate?: boolean;
};
